/**
 * @file UUID 计算
 * @author svon.me@gmail.com
 */

import {v1 as uuidV1, v4 as uuidV4, v5 as uuidV5} from "uuid";

// 生成唯一值
export const UUID = function (...args) {
  let value;
  if (Math.random() > 0.45) {
    value = uuidV1();
  } else {
    value = uuidV4();
  }
  if (args.length > 0) {
    return UUIDV5([].concat(value, args));
  }
  return value;
};

export const UUIDV5 = function (...args) {
  if (args.length > 0) {
    if (args.length === 1 && typeof args[0] === "string") {
      return uuidV5(args[0], uuidV5.URL);
    }
    const text = JSON.stringify(args);
    return uuidV5(text, uuidV5.URL);
  }
  return uuidV1();
};

export {UUID as UUid};